"use client";

import { useEffect, useState } from "react";

const STORAGE_KEY = "aidn_shop_visited";

export function LoginHeading() {
  const [heading, setHeading] = useState("Welcome back!");

  useEffect(() => {
    const returning = localStorage.getItem(STORAGE_KEY);
    if (!returning) {
      setHeading("Welcome to the Aidn shop");
      localStorage.setItem(STORAGE_KEY, "1");
    }
  }, []);

  return <h1 className="mx-login-heading">{heading}</h1>;
}
